/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  console.log('custom js loaded');

  document.addEventListener('DOMContentLoaded', () => {
  if (!window.subscribe || !window.theme?.PUB_SUB_EVENTS?.variantChange) return;

  window.subscribe(
      window.theme.PUB_SUB_EVENTS.variantChange,
      ({ data: eventData }) => {
        const { sectionId, variant } = eventData;
        const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
        const productGallery = document.querySelector(`.product-gallery--${sectionId}`);
        const productHandle = productGallery?.getAttribute('handle');
        const variantId = variant?.id;
        
        fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(productHandle)}?variant=${encodeURIComponent(variantId)}&section_id=${sectionId}`)
        .then((response) => response.text())
        .then((data) => {
          const html = new DOMParser().parseFromString(data, 'text/html');
          const productImagesDestination = html.querySelector('product-info .product-gallery');
          if (productImagesDestination) productGallery.replaceWith(productImagesDestination);

          // trigger flickity slider
          productInfo.destroyProductSlider?.();
          productInfo.productSlider?.();   // re-enables Flickity only if the theme conditions pass
          productInfo.initMediaSwitch?.(); // rebinds thumbnail events
        })
        .catch((error) => console.error('Failed to update product images after variant change:', error));
      }
    );
  });


})();